import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import authReducer from './reducers/auth'
import messageReducer from './reducers/message'
import loadingReducer from './reducers/loading'
import currentPageReducer from './reducers/currentPage'
import thirdPartyReducer from './reducers/thirdParty'
import inventoryReducer from './reducers/inventory'
import shopReducer from './reducers/shop'
import pluginsReducer from './reducers/plugins'
import tvSettingsReducer from './reducers/tvSettings'
import companyReducer from './reducers/company'
import reportingReducer from './reducers/reporting'
import settingReducers from './reducers/shopSetting'
import integrationReducer from './reducers/integration'
import pricingTemplateReducer from './reducers/pricingTemplate'
import adjustmentsReducer from './reducers/adjustments'
import kioskSettingsReducer from './reducers/kioskSettings'
import employeeReducer from './reducers/employee'
import weightToleranceReducer from './reducers/weightTolerance'
import organizationReducer from './reducers/organization'
import posTerminalReducer from './reducers/posTerminal'
import masterCatalogReducer from './reducers/masterCatalog'
import batchReducer from './reducers/batch'
import dispatchReducer from './reducers/dispatch'
import flagReducer from './reducers/flag'

import thunk from 'redux-thunk'

const reducer = combineReducers({
  authReducer,
  messageReducer,
  loadingReducer,
  currentPageReducer,
  thirdPartyReducer,
  inventoryReducer,
  shopReducer,
  posTerminalReducer,
  pluginsReducer,
  tvSettingsReducer,
  companyReducer,
  reportingReducer,
  settingReducers,
  integrationReducer,
  pricingTemplateReducer,
  adjustmentsReducer,
  kioskSettingsReducer,
  employeeReducer,
  weightToleranceReducer,
  organizationReducer,
  masterCatalogReducer,
  batchReducer,
  dispatchReducer,
  flagReducer,
})

const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)))

export default store



// WEBPACK FOOTER //
// ./src/store.js